import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { colors } from "../styles/theme";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("");

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const handleHashChange = () => {
    const hash = window.location.hash;
    const currentPage = hash.replace(/#\//, "");

    if (currentPage) {
      setActiveItem(currentPage);
    } else {
      setActiveItem("home");
    }
  };

  // useEffect(() => {
  //   handleHashChange();
  // }, [window.location.hash]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("hashchange", handleHashChange);

    if (!isHomePage) {
      setIsScrolled(true);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [isHomePage]);

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false);
    setActiveItem(sectionId);

    if (window.location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetTop = element.offsetTop - 80;
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    }
  };

  const navItems = [
    { id: "home", label: "Главная", path: "/" },
    { id: "gallery", label: "Галерея", path: "/gallery" },
    { id: "sitemap", label: "Карта сайта", path: "/sitemap", mobileOnly: true },
  ];

  const shouldBeTransparent = isHomePage && !isScrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all ${
        shouldBeTransparent
          ? "bg-transparent py-4"
          : "bg-white/95 backdrop-blur-md shadow-md py-2"
      }`}
    >
      <div className="container">
        <div className="flex justify-between items-center">
          <Link
            to="/"
            className={`header-logo transition-all ${
              shouldBeTransparent ? "text-white" : "text-olive"
            }`}
            onClick={() => scrollToSection("home")}
          >
            Лесная Усадьба
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:block">
            <ul className="flex gap-6">
              {navItems.filter(item => !item.mobileOnly).map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.path}
                    className={`nav-link ${
                      activeItem === item.id ? "active" : ""
                    } ${shouldBeTransparent ? "text-white" : "text-gray-700"}`}
                    onClick={(e) => {
                      if (item.path.startsWith("/#")) {
                        e.preventDefault();
                        scrollToSection(item.id);
                      } else {
                        setIsMenuOpen(false);
                      }
                    }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-full hover:bg-black/5 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Закрыть меню" : "Открыть меню"}
          >
            {isMenuOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke={shouldBeTransparent ? "white" : colors.neutral.darkest}
                className="transition-all"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke={shouldBeTransparent ? "white" : colors.neutral.darkest}
                className="transition-all"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-lg py-4 animate-fade-in-down">
          <div className="container">
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.path}
                    className={`block py-2 px-4 rounded-md transition-colors ${
                      activeItem === item.id
                        ? "bg-terracotta/10 text-terracotta font-medium"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                    onClick={(e) => {
                      if (item.path.startsWith("/#")) {
                        e.preventDefault();
                        scrollToSection(item.id);
                      } else {
                        setIsMenuOpen(false);
                      }
                    }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
